module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.e393bcc6.svg";